import { Blockquote, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function Address() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Head office
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    Baslerstraße 115, <br/>
                    79115 Freiburg im Breisgau, <br/>
                    Germany<br/><br/>
                    Tel.: <br/>
                    0049 17613637834 <br/>  0039 392 3768 246 <br/>  0049 176 4766 4552<br/><br/>
                    Email: <b>intersticesctt@gmail.com</b>
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Foreign office
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    Colle Labirinto 24, <br/>
                    00039 Zagarolo, <br/>
                    Italy
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>



      </div>
      
      <AddBottomSpace />
    </>
  )
}
